import React from "react";

export default function ProjectInfo() {
  return (
    <p className="info">
      This project has been created using ReactJS on CodeSandbox. It includes
      implementation of React Hooks - useState, useEffect, useReducer &
      useContext.
    </p>
  );
}
